import React, { useRef, useEffect, useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import Tooltip from "@mui/material/Tooltip";
import cloth from "../../../assets/svg/cloth.svg";

const PointItem = ({ text }) => {
  const spanRef = useRef(null);
  const [isOverflowed, setIsOverflowed] = useState(false);

  useEffect(() => {
    if (spanRef.current) {
      const { scrollWidth, clientWidth } = spanRef.current;
      setIsOverflowed(scrollWidth > clientWidth);
    }
  }, [text]);

  return (
    <Tooltip title={isOverflowed ? text : ""} arrow disableHoverListener={!isOverflowed}>
      <div className="flex items-start gap-2 text-sm text-gray-700">
        <CheckCircleIcon className="text-green-500 mt-0.5" fontSize="small" />
        <span
          ref={spanRef}
          className="truncate whitespace-nowrap overflow-hidden"
        >
          {text}
        </span>
      </div>
    </Tooltip>
  );
};

const DiscountCard = ({
  cardDetails,
  isSelected = false,
  onEdit = () => {},
  onDelete = () => {},
}) => {
  return (
    <div
      className={`relative w-[280px] xs:w-[320px] lg:w-[340px] h-[330px] p-4 xs:p-6 bg-[#E9F2F9] rounded-2xl shadow-xl border-2 transition-all duration-300 ${
        isSelected ? "border-[#2196F3]" : "border-transparent"
      }`}
    >
      {/* Edit/Delete Icons */}
      <div className="absolute top-2 right-2 flex space-x-2">
        <button
          onClick={() => onEdit(cardDetails)}
          className="bg-white shadow p-1 rounded hover:scale-110 transition"
        >
          <EditIcon fontSize="small" />
        </button>
        <button
          onClick={() => onDelete(cardDetails)}
          className="bg-white shadow p-1 rounded hover:scale-110 transition"
        >
          <DeleteIcon fontSize="small" />
        </button>
      </div>

      {/* Title */}
      <div className="mb-2 mt-8 flex items-center justify-center gap-2">
        <img src={cloth} alt="cloth" className="w-6 h-6" />
        <div className="text-[25px] lg:text-[30px] font-[500] text-[#222]">

       Clothes
        </div>
      </div>

      <hr className="border-gray-300 mb-4" />
       <div className="text-[25px] lg:text-[30px]  text-center font-[500] text-[#222]">
          {cardDetails.minQnt}-{cardDetails.maxQnt} <br /> {cardDetails?.serviceType === "WASH_N_FOLD" ? "lbs" : "Items"} 
        </div>

      <div className="text-[50px] text-center font-extrabold text-[#222] mb-6">
        {cardDetails.discount}% OFF
      </div>

      {/* Points */}
      {/* <div className="space-y-2 max-h-[140px] overflow-auto pr-1">
        {cardDetails.points.map((text, index) => (
          <PointItem key={index} text={text} />
        ))}
      </div> */}
    </div>
  );
};

export default DiscountCard;
